import { Box, Modal, Typography } from "@mui/material";
import React from "react";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: "auto",
  width: { xs: "90%", md: "auto" },
  maxHeight: 700,
  bgcolor: "#FFFFFF",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
  overflowY: "auto",
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-track": {
    boxShadow: "inset 0 0 5px grey",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "darkgrey",
    borderRadius: "10px",
  },
};

const SSPCommonModal = ({ open, handleOpenClose, message, title }) => {
  const handleClose = () => handleOpenClose(!open);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{ fontWeight: "bold", margin: 2 }}
        >
          {title}
        </Typography>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{ margin: 1 }}
        >
          {message}
        </Typography>
      </Box>
    </Modal>
  );
};

export default SSPCommonModal;
